import {
	SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	SET_HEADER_NAVIGATION_STATE_FULFILLED,
} from '../constants/actions/navigationActions';

export const closeMobileNav = () => ({
	type: SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	payload: {
		open: false,
	},
});

export const setMobileNavDisplayState = (open: boolean) => ({
	type: SET_MOBILE_NAVIGATION_STATE_FULFILLED,
	payload: {
		open,
	},
});

export const setHeaderNavDisplaystate = (open: boolean, id: number) => ({
	type: SET_HEADER_NAVIGATION_STATE_FULFILLED,
	payload: {
		id,
		open,
	},
});
